// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2388":"e953f18d","4310":"589183b5","4758":"779523b1","6152":"e953f18d","9374":"e953f18d"}[chunkId] + ".chunk.css";
};